import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { SettingsContext } from "../../SettingsContext";
import VenueSelectorComponent from "./components/VenueSelectorComponent";
import ManufacturerSelectorComponent from "./components/ManufacturerSelectorComponent";
import ItemSelectorComponent from "./components/ItemSelectorComponent";
import UserCountryComponent from "./components/UserCountryComponent";
import UserGenderComponent from "./components/UserGenderComponent";
import UserAgeComponent from "./components/UserAgeComponent";
import {
    StyledSelect,
    StyledLabel,
    FormGroup
} from '../../../shared/layout/forms/FormElements';

import ItemCard from '../../../shared/layout/cards/ItemCard';

const ConditionComponent = ({ condition, index, onDelete }) => {
    const { siteSettings } = useContext(SettingsContext);
    const conditionTypes = siteSettings?.getConditionTypes() || [];
    const [, forceUpdate] = useState(0);

    const selectedType = condition.typeId
        ? conditionTypes.find(type => type.id === condition.typeId)
        : null;

    const selectedAttribute = selectedType?.attributes.find(attr => attr.id === condition.attributeId);

    const handleTypeChange = (event) => {
        const newTypeId = event.target.value;
        condition.typeId = newTypeId;
        condition.attributeId = '';
        condition.value = '';
        condition.operator = '';
        forceUpdate(prev => prev + 1);
    };

    const handleAttributeChange = (event) => {
        const newAttributeId = event.target.value;
        condition.attributeId = newAttributeId;
        condition.value = '';
        condition.operator = '';
        forceUpdate(prev => prev + 1);
    };

    const handleValueChange = (field, value) => {
        condition[field] = value;
        forceUpdate(prev => prev + 1);
    };

    const title = `Condition ${index + 1}: ${selectedType?.name || 'New'} - ${selectedAttribute?.label || ''}`;

    return (
        <ItemCard title={title} onDelete={onDelete}>
            <FormGroup>
                <StyledLabel htmlFor="conditionType">Condition Type</StyledLabel>
                <StyledSelect
                    id="conditionType"
                    value={condition.typeId || ''}
                    onChange={handleTypeChange}
                >
                    <option value="">Select Condition Type</option>
                    {conditionTypes.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.name}
                        </option>
                    ))}
                </StyledSelect>
            </FormGroup>

            {selectedType && (
                <FormGroup>
                    <StyledLabel htmlFor="conditionAttribute">Condition Attribute</StyledLabel>
                    <StyledSelect
                        id="conditionAttribute"
                        value={condition.attributeId || ''}
                        onChange={handleAttributeChange}
                    >
                        <option value="">Select Attribute</option>
                        {selectedType.attributes.map(attr => (
                            <option key={attr.id} value={attr.id}>
                                {attr.label}
                            </option>
                        ))}
                    </StyledSelect>
                </FormGroup>
            )}

            {selectedAttribute && (
                <div style={{ marginTop: '12px' }}>
                    {(() => {
                        switch (selectedAttribute.key) {
                            case 'age':
                                return (
                                    <UserAgeComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'gender':
                                return (
                                    <UserGenderComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'country':
                                return (
                                    <UserCountryComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'item_id':
                                return (
                                    <ItemSelectorComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'manufacturer_id':
                                return (
                                    <ManufacturerSelectorComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'venue_id':
                                return (
                                    <VenueSelectorComponent
                                        value={condition.value}
                                        operator={condition.operator}
                                        target="conditions"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            default:
                                return null;
                        }
                    })()}
                </div>
            )}
        </ItemCard>
    );
};

export default ConditionComponent;
